import { AlertTriangleIcon, CheckCircleIcon } from "../Icons.js";

export interface VerdictExplanationProps {
  summary?: string;
  risks: string[];
  positives: string[];
  signals: Array<{ type: string; severity: string; message: string }>;
  riskLevel: string;
}

export function VerdictExplanation({ summary, risks, positives, signals }: VerdictExplanationProps) {
  const hasContent = summary || risks.length > 0 || positives.length > 0 || signals.length > 0;
  if (!hasContent) return null;

  return (
    <div className="intel-section-group">
      <h2 className="intel-section-header">Why This Verdict</h2>
      <p className="intel-section-desc">Key factors that determined this token's safety assessment.</p>

      {/* AI Summary */}
      {summary && (
        <div className="intel-verdict-summary">
          <p>{summary}</p>
        </div>
      )}

      {/* Risk & Positive findings — 2 column grid */}
      {(risks.length > 0 || positives.length > 0) && (
        <div className="intel-grid intel-grid-2" style={{ marginTop: summary ? '1rem' : 0 }}>
          {risks.length > 0 && (
            <div className="card intel-list-card intel-risks-card">
              <h3 className="intel-subsection-title" style={{ color: "#e74c3c" }}>
                <AlertTriangleIcon
                  className="intel-section-icon"
                  style={{ color: "#e74c3c" }}
                  aria-hidden="true"
                />
                Risk Findings ({risks.length})
              </h3>
              <ul>
                {risks.map((r, i) => (
                  <li key={i}>{r}</li>
                ))}
              </ul>
            </div>
          )}
          {positives.length > 0 && (
            <div className="card intel-list-card intel-positives-card">
              <h3 className="intel-subsection-title" style={{ color: "#27ae60" }}>
                <CheckCircleIcon
                  className="intel-section-icon"
                  style={{ color: "#27ae60" }}
                  aria-hidden="true"
                />
                Positive Findings ({positives.length})
              </h3>
              <ul>
                {positives.map((p, i) => (
                  <li key={i}>{p}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      {/* Active Signals */}
      {signals.length > 0 && (
        <div className="intel-signals-list" style={{ marginTop: '0.75rem' }}>
          {signals.map((sig, i) => (
            <div
              key={i}
              className={`intel-signal intel-signal-${sig.severity}`}
            >
              <span className="intel-signal-badge">{sig.severity}</span>
              <span className="intel-signal-type">{sig.type}</span>
              <span className="intel-signal-msg">{sig.message}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
